class MainProductContext extends HTMLElement {
  constructor() {
    super();
    this.productOptions = this.querySelector('main-product-options');
    this.productHandle = this.getAttribute('product-handle');
    this.upsellCheckboxes = this.querySelectorAll('upsell-checkbox');
    this.productForm = this.querySelector('product-form');
    this.bundlesSlider = this.querySelector('#main-product-bundle-slider');
    this.isNewVersion = this.hasAttribute('new-version');
  }

  upsellProducts = [];

  connectedCallback() {
    if (this.productOptions) {
      this.productOptions.addEventListener('variant-change', this.handleOptionChange.bind(this));
    }
    if (this.upsellCheckboxes) {
      this.upsellCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('upsell-checkbox-change', this.handleUpsellCheckboxChange.bind(this));
      });
    }
  }

  handleOptionChange(event) {
    this.currentVariant = event.detail;
    if (this.currentVariant) {
      this.updateSections();
      this.updateBundlesSlider();
    }
  }

  handleUpsellCheckboxChange(event) {
    if (event.detail.checked) {
      this.upsellProducts.push(event.detail.productId);
    } else {
      this.upsellProducts = this.upsellProducts.filter((productId) => productId !== event.detail.productId);
    }
    this.productForm.upsellProducts = this.upsellProducts;
  }

  updateSections() {
    // The Section Rendering API returns at most 5 sections per request.
    const sectionNames = this.getSectionsToRender().map((section) => section.section);
    const batches = [];
    for (let i = 0; i < sectionNames.length; i += 5) {
      batches.push(sectionNames.slice(i, i + 5).join(','));
    }

    const url = `${window.Shopify.routes.root}products/${this.productHandle}?variant=${this.currentVariant.id}`;
    Promise.all(batches.map((batch) => fetch(`${url}&sections=${batch}`).then((response) => response.json())))
      .then((responses) => {
        this.handleSectionsResponse(Object.assign({}, ...responses));
      })
      .catch((error) => {
        console.error('Failed to load sections', error);
      });
  }

  handleSectionsResponse(sections) {
    // Blocks of this section can't come back from the Section Rendering API,
    // so the live elements are kept and moved into their slot in the new markup.
    const preserved = Array.from(this.querySelectorAll('[data-preserve-on-render]'));

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
    });

    preserved.forEach((element) => {
      const slot = this.querySelector(`[data-preserve-slot="${element.dataset.preserveOnRender}"]`);
      if (slot) slot.replaceWith(element);
    });
    this.dispatchEvent(new CustomEvent('sections-rendered', { 
      detail: { sections }, 
      bubbles: true 
    }));
  }

  updateBundlesSlider() {
    const request = new XMLHttpRequest();
    request.addEventListener('load', (event) => {
      try {
        this.handleBundlesSliderResponse(event);
      } catch (error) {
        console.error(error);
      }
    });
    request.open('GET', `${window.Shopify.routes.root}products/${this.productHandle}?variant=${this.currentVariant.id}&sections=main-product-bundle-slider`, true);
    request.send();
  }

  handleBundlesSliderResponse(event) {
    const sections = JSON.parse(event.target.response);
    this.bundlesSlider.innerHTML = this.getSectionInnerHTML(sections['main-product-bundle-slider'], '.shopify-section');
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-product-images',
        section: 'main-product-images',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-info',
        section: 'main-product-info',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-info-mobile',
        section: 'main-product-info-mobile',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-form',
        section: 'main-product-form',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-accordions',
        section: this.isNewVersion ? 'product-accordions-new' : 'product-accordions',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-sticky-bar',
        section: 'main-product-sticky-bar',
        selector: '.shopify-section',
      },
    ].filter((section) => document.getElementById(section.id));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('main-product-context', MainProductContext);